//frontend/src/pages/dashboard/Dashboard.jsx
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-6 flex justify-between items-center">
          <h1 className="text-3xl font-bold text-gray-900">
            🚀 Pingo Dashboard
          </h1>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
          >
            Гарах
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* Success Card */}
        <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-bold text-green-800 mb-2">
            ✅ Амжилттай нэвтэрлээ!
          </h2>
          <p className="text-green-700">
            Backend + Frontend холболт ажиллаж байна!
          </p>
        </div>

        {/* User Info */}
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">
            👤 Хэрэглэгчийн мэдээлэл
          </h3>
          <div className="space-y-3">
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">ID:</span>
              <span className="text-gray-800">{user?.id}</span>
            </div>
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">Нэр:</span>
              <span className="text-gray-800">{user?.full_name}</span>
            </div>
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">Username:</span>
              <span className="text-gray-800">{user?.username}</span>
            </div>
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">Email:</span>
              <span className="text-gray-800">{user?.email || 'Байхгүй'}</span>
            </div>
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">Role:</span>
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold">
                {user?.role}
              </span>
            </div>
            <div className="flex border-b pb-2">
              <span className="font-semibold text-gray-600 w-40">User Type:</span>
              <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm font-semibold">
                {user?.user_type}
              </span>
            </div>
            {user?.company_id && (
              <div className="flex border-b pb-2">
                <span className="font-semibold text-gray-600 w-40">Company ID:</span>
                <span className="text-gray-800">{user.company_id}</span>
              </div>
            )}
            {user?.shop_id && (
              <div className="flex border-b pb-2">
                <span className="font-semibold text-gray-600 w-40">Shop ID:</span>
                <span className="text-gray-800">{user.shop_id}</span>
              </div>
            )}
          </div>
        </div>

        {/* Test Info */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-bold text-blue-800 mb-2">
            🎉 Дараагийн алхам:
          </h3>
          <ul className="list-disc list-inside text-blue-700 space-y-1">
            <li>Company Management APIs</li>
            <li>Product Management</li>
            <li>Delivery System</li>
            <li>Dashboard Statistics</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;